import PropTypes from "prop-types";
import ShopProductCard from "../../../pages/ShopV2/components/ProductCard";

export default function ProductCard({ data: product, style }) {
  return (
    <div style={style}>
      <ShopProductCard
        product={product}
        to={`/${product.route}/${product.product_id}`}
      />
    </div>
  );
}

ProductCard.propTypes = {
  data: PropTypes.object,
  style: PropTypes.object,
};
